module.exports = __webpack_public_path__ + "img/defaultVoucherIco.657b7e00.png";